import { Token } from '@frontend/authentication-v2';
import { AuthorizationClient, UserPermissions } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';

const hasOrderRight = (permissions: UserPermissions): boolean =>
    Object.values(permissions).some((items) => Object.values(items).some((rights) => rights[Rights.ORDER]?.length > 0));

/** Fetches the authenticated user's effective permissions once to decide whether the order catalogue is relevant. */
export const canOrderProducts = async (userToken: Token): Promise<boolean> => {
    try {
        const permissions = await AuthorizationClient.fetchPermissions(userToken);
        return hasOrderRight(permissions);
    } catch {
        return false;
    }
};

/** Verifies that the authenticated user may order a specific product before it is added to the basket. */
export const canOrderProduct = async (accountId: string, productId: string, userToken: Token): Promise<boolean> => {
    try {
        const rights = await AuthorizationClient.fetchMyEntityPermissions(accountId, EntityType.PRODUCT, productId, userToken);
        return rights.includes(Rights.ORDER);
    } catch {
        return false;
    }
};
